// https://www.jianshu.com/p/d1ecb0c36765
const s = /android/.test(navigator.userAgent.toLowerCase()) ? '0.15s' : '0.2s';
const transitionStyle = `${s} height cubic-bezier(0.2, 0.8, 0.2, 1)`;
const Transition = {
  beforeEnter (el) {
    el.style.transition = transitionStyle
    if (!el.dataset) el.dataset = {}

    el.style.height = 0
  },

  enter (el) {
    if (el.scrollHeight !== 0) {
      setTimeout(() => {
        // console.log(`${el.scrollHeight}px`, '~~~~~~~0');
        el.style.height = `${el.scrollHeight}px`
      },0)
      
    } else {
      el.style.height = ''
    }
    el.style.overflow = 'hidden'
  },

  afterEnter (el) {
    el.style.transition = ''
    // el.style.height = ''
  },

  beforeLeave (el) {
    if (!el.dataset) el.dataset = {}
      // console.log(`${el.scrollHeight}px`, '~~~~~~~1');
    el.style.height = `${el.scrollHeight}px`
    el.style.overflow = 'hidden'
  },

  leave (el) {
    if (el.scrollHeight !== 0) {
      el.style.transition = transitionStyle
      el.style.height = 0
    }
  },

  afterLeave (el) {
    el.style.transition = ''
    // el.style.height = ''
  }
}

export default {
  name: 'CollapseTransition',
  functional: true,
  render (h, {
    children
  }) {
    const data = {
      on: Transition
    }
    return h('transition', data, children)
  }
}


// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/viphalfscreen/js/collapse-transition.js